import { Offer, OfferData } from '../../providers/api/dtos';

export function isOffer(offer: Offer | OfferData): offer is Offer {
  return 'status' in offer && 'intentId' in offer;
}
